
    import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
    import {inspectionOrderApi} from "@/api/inspection";
    import baseUrl, {imageUrl, uploadPage} from "@/constants";
    import {rulesApi} from "@/api/rules";
    import guid from "@/common/guid";
    import {dictApi, fileApi} from "@/api/organization";
    import {instrumentApi} from "@/api/instrument";
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    const {CodeToText, regionData} =require("@/js/region/region");

    @Component({
        name: "ImportPreview",
        components: {ckeditor4}
    })
    export default class ImportPreview extends Vue {
        title = "待办检定器具导入导出预览弹窗";
        certificateType = "";
        ImportPreviewDialog = true;
        form = {
            certificateType: "",   //证书类型
            certificationNumber: "",   //证书编号
            basedRuleName: "",   //检定依据名称
            checkPersonName: "",   //检定员姓名/校准员姓名
            checkCocn: "",   //检定结论
            reApproverName: "",   //核验员
            inspectionDate: "",   //检定日期/校准日期
            approverName: "",   //批准人
            expireDate: "",   //有效期至
            enclosure: "",   //影印件

            receiptDate: "",  //接收日期
            issueDate: "",  //签发日期
        } as any;
        form2 = {} as any;
        basedRuleName = "";  //检定依据
        rules = {
            certificateType: [{ required: true, message: '请选择检定/校准类型', trigger: 'change' }],
            certificationNumber: [{ required: true, message: '请输入证书编号', trigger: 'blur' }],
            checkPersonName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
            checkCocn: [{ required: true, message: '请输入结论', trigger: 'blur' }],
            reApproverName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
            inspectionDate: [{ required: true, message: '请输入日期', trigger: 'blur' }],
            approverName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
            expireDate: [{ required: true, message: '请输入有效期', trigger: 'blur' }],
            enclosure: [{ required: true, message: '请上传检定结果复印件', trigger: 'change' }],
            issueDate: [{ required: true, message: '请输入日期', trigger: 'blur' }],
        }
        fileListCheck = [] as any;
        baseUrl = baseUrl;
        imageUrl = imageUrl;
        headers = {Authorization:""}
        imgGuid = guid();

        showOnlyForm = {
            name: "",
            typeCode: "",
            purposeCode: "",
            modelSpecific: "",
            useUnit: "",
            useAddrCodeArr: "",
            manufactoryName: "",
        } as any;
        typeCodeList = [];
        purposeCodeList = [];
        listInstrument = [] as any //器具备选列表
        props = {
            value: 'instrumentNameId',
            label: 'name',
        }
        regionData = regionData;
        id = 0;

        excelFileList = [] as any;


        /**
         * 编辑的data
         * */
        @Prop() private data!: any;
        // 0导出  1导入
        @Prop() private showType!: any;

        created() {
            if(this.data.length > 0){
                this.id = this.data[0].instrumentId;
            }

            this.getDict(1);
            this.getDict(2);
            this.getListInstrument();
            // this.getRules();
            if(this.id > 0 && this.showType == 0){
                this.getInstrmentDetail();
            }
        }
        getDict(category: number, code: string | string = ""){
            return dictApi.list({
                category: category,
                code: code
            }).then(r=>{
                if(r.data.result === 0){
                    const rData = r.data.data;
                    if(category == 1){
                        this.typeCodeList = rData;
                    }else if(category == 2){
                        this.purposeCodeList = rData;
                    }
                }
            })
        }
        //获取器具备选列表个
        getListInstrument(){
            return dictApi.listDictInstrument().then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData);
                    this.listInstrument = rData;
                }
            })
        }
        porjectTree(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length > 0){
                    this.porjectTree(project.children);
                }else{
                    project.children = null;
                }
            })
        }
        getInstrmentDetail(){
            instrumentApi.getDetailById({id:this.id}).then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.showOnlyForm = rData;
                    this.showOnlyForm.useAddrCodeArr = rData.useAddrCode ? rData.useAddrCode.split(",") : [];
                    this.$nextTick(()=>{
                        const arr = [];
                        arr.push(Number(rData.majorCode));
                        arr.push(Number(rData.classCode));
                        arr.push(Number(rData.categoryCode));
                        arr.push(Number(rData.instrumentNameId));
                        this.showOnlyForm.name = arr;
                    })
                }
            })
        }
        //保存检定证书/结果
        onSubmit() {
            //影印件****
            const enclosureList = this.fileListCheck.map((e:any)=>{
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl,"")
                }
            })
            this.form.enclosure = enclosureList.length === 0 ? "" :  JSON.stringify(enclosureList);
            //影印件end****
            let form = this.$refs.form as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    let params: any;
                    //如果未通过  则只存结果
                    params = {...this.form, submitForm: 1};
                    // if(this.specialAddExamine){
                    //     params = Object.assign(params, {orderInstrumentsId: this.id});
                    // }else{
                    //     params = Object.assign(params, {instrumentsId: this.id});
                    // }
                    // params.orderInstrumentsId = this.editData.id;

                    inspectionOrderApi.updateInspectionOrderInstruments(params).then(r=>{
                        if(r.data.result === 0){
                            this.$message.success("保存成功");
                            this.clostDialog();
                        }
                    })

                    // let api;
                    // if(params.id){
                    //     api = inspectionOrderApi.updateInspectionOrderInstrumentsById(params);
                    // }else{
                    //     api = inspectionOrderApi.updateInspectionOrderInstruments(params);
                    // }
                    // api.then(r=>{
                    //     if(r.data.result === 0){
                    //         this.$message.success("保存成功");
                    //         this.clostDialog();
                    //     }
                    // })
                }
            });
        }
        getForm(){
            return {
                certificationNumber: "",   //证书编号
                certificateType: "",       //证书类型
                inspectionDate: "",        //检定日期
                expireDate: "",            //有效期
                checkCocn: "",             //检定结论
                checkResult: 1,           //检定状态
                resultText: "",                //检定结果
                basedRuleId: "",           //检定依据
                basedRuleName: "",         //检定依据名称
                reason: "",                //不合格原因
                checkPersonId: "",         //检定员id
                checkPersonName: "",       //检定员姓名
                checkPersonCardCode: "",   //检定员身份证号
                reApproverId: "",          //核验员id
                reApproverName: "",        //核验员姓名
                reApproverCardCode: "",    //核验员身份证号
                approverId: "",            //批准人id
                approverName: "",          //批准人名称
                approverCardCode: "",      //批准人身份证号
            }
        }
        measuringRules = [] as any //规程规范
        measuringRulesFilterd = [] as any //过滤后的规程规范
        getRules(){
            return rulesApi.page({current: -1}).then((r) => {
                if(r.data.result === 0){
                    this.measuringRules = r.data.data.records;
                }
            });
        }
        changeBasedRule(value: any){
            const rule = this.measuringRules.find((rule: any) => rule.id === value);
            this.form.basedRuleName = rule.number + " " + rule.name;
        }
        filterRules(keyword: string){
            if(keyword !=""){
                let key1 = ""; // 正则匹配出 [A-Z]+
                let key1s = /[A-Za-z]+/i.exec(keyword);
                if(key1s != null && key1s.length > 0){
                    key1 = key1s[0].toUpperCase();
                }

                let key2 = ""; //正则匹配出 \d+
                let key2s = /[\d-]+/i.exec(keyword);
                if(key2s != null && key2s.length > 0){
                    key2 = key2s[0];
                }

                let key3 = ""; //正则匹配出 常见汉字
                let key3s = /[\u4E00-\u9FFF]+/i.exec(keyword);
                if(key3s != null && key3s.length > 0){
                    key3 = key3s[0];
                }
                this.measuringRulesFilterd = this.measuringRules.filter((item: any) =>
                    (key1 == "" || item.number.toUpperCase().indexOf(key1) != -1)
                    && (key2 == "" || item.number.indexOf(key2) != -1)
                    && (key3 == "" || item.number.indexOf(key3) != -1)
                );
            }else{
                this.measuringRulesFilterd = [];
            }
        }

        //上传检定结果复印件
        //上传监控
        handleAvatarSuccessCheck(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.fileListCheck.push({name: "检定结果.pdf",url: imageUrl+rData})
            }
        }
        handleRemoveCheck(file: any, fileList: any) {
            const index = this.fileListCheck.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileListCheck.splice(index, 1);
            }
            fileApi.deleteTemporaryFile({uuid: this.imgGuid})
        }
        handlePictureCardPreviewCheck(file: any) {
            const fix = this.filesuffix(file.url);
            if(fix == "pdf"){
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl,"") + "&name=" + file.name, '_blank');
            }
        }
        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }
        //上传监控
        beforeAvatarUploadCheck(file: any) {
            const isPDF = file.type === 'application/pdf';
            if (!isPDF) {
                this.$message.error('上传图片只能是PDF格式!');
            }
            return (isPDF);
        }

        clostDialog() {
            this.$emit("clostDialog")
        }

    //    导出按钮
        exportBtn(){
            if(this.certificateType == ""){
                this.$message.error("请选择证书类型");
                return;
            }
            const ids = this.data.flatMap((e:any)=>e.instrumentId).join(",");
            const params = {instrumentIds: ids, certificateType: this.certificateType };
            inspectionOrderApi.exportInstruments(params).then((res: any) => {
                if (res.data.result === 0) {
                    const rData = res.data.data;
                    this.$message.success("导出成功");
                    window.open(baseUrl + "/file/download?file=" + rData + "&name=" + "待办器具", '_blank');
                }
            });
        }
        //导入保存
        importBtn(){
            if(this.certificateType == ""){
                this.$message.error("请选择证书类型");
                return;
            }
            if(this.excelFileList.length == 0){
                this.$message.error("请上传excel");
                return;
            }
            if(this.fileListCheck.length == 0){
                this.$message.error("请上传证书/合格证影印件");
                return;
            }

            this.importInstrumentReport(this.excelFileList[0].url.replace(imageUrl,""), false, this.fileListCheck[0].url.replace(imageUrl,""));
        }
        //    导入excel
        excelSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.excelFileList.push({name: "导入文件",url: imageUrl+rData})
                // this.$message.success("上传成功");
                this.importInstrumentReport(rData, true, "");
            }
        }
        importInstrumentReport(file: string,first: boolean,pdfPath: string){
            inspectionOrderApi.importInstrumentReport({file: file, first: first,pdfPath:pdfPath, certificateType: this.certificateType }).then((res: any) => {
                if (res.data.result === 0) {
                    if(first){
                        const rData = res.data.data;
                        this.id = rData.instrumentId;
                        this.basedRuleName = rData.basedRuleName;
                        this.getInstrmentDetail();
                    }else{
                        this.$message.success("导入成功");
                        this.clostDialog();
                    }
                }else{
                    this.excelFileList = [];
                }
            });
        }
        excelRemove(file: any, fileList: any) {
            const index = this.excelFileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.excelFileList.splice(index, 1);
            }
        }
        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if (fix == "pdf" || fix == "xlsx" || fix == "xls") {
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
            }
        }
    }
